import React from "react";
import {DatePicker} from "antd";
import {DateRangePickerInputBoxProps} from "./interface";
import {SplitInputWrapperProps, InputWrapper} from "../../functions";
import {CONSTANT} from "../../../../config/Constant";
import {validations} from "../../../../config/validations/validations";
import {toLowerCaseWithUnderscore} from "../../../AgGridWrapper/utils/commonFunctions";

const DateRangePickerInputBox: React.FC<DateRangePickerInputBoxProps> = (props) => {
    const {
        formProps: {rules = [], ...formProps},
        inputProps: {format, showTime = false, ...inputProps},
    } = SplitInputWrapperProps(props);

    if (formProps?.required) {
        rules.filter((rule: any) => rule.required).length === 0 &&
            rules.push(validations.required.other());
    }

    const newFormat = format
        ? format
        : !showTime
        ? CONSTANT.DATE_FORMAT
        : CONSTANT.DATE_TIME_FORMAT;
    return (
        <InputWrapper
            name={formProps?.label && toLowerCaseWithUnderscore(formProps?.label)}
            rules={rules}
            {...formProps}
        >
            <DatePicker.RangePicker format={newFormat} {...inputProps} showTime={showTime} />
        </InputWrapper>
    );
};

export default DateRangePickerInputBox;
